





















import { Component, Vue, Ref } from "vue-property-decorator";
import BaseDialogComponent from "@/components/common/BaseDialog.vue";
import { tryJoinSharedEmailAddress } from "@/data/repository/SharedEmailAddressRepository";
import { getActiveUser } from "@/data/repository/UserRepository";

interface JoinSharedEmailAddressData {
  userId: string;
  userNickname: string;
  sharedEmailAddressId: string;
  emailAddress: string;
  clientName: string;
  createdBy: string;
}

@Component({
  components: {
    "base-dialog": BaseDialogComponent,
  },
})
export default class JoinSharedEmailAddressComponent extends Vue {
  password = "";
  showPassword = false;
  passwordError: string[] = [];

  isLoading = false;
  message = "";

  @Ref("baseDialog")
  baseDialogComponent!: BaseDialogComponent;

  resolve?: (value: boolean) => void = undefined;
  reject?: (reason: string) => void = undefined;

  toggleShowPassword() {
    this.showPassword = !this.showPassword;
  }

  data!: JoinSharedEmailAddressData;

  async show(data: JoinSharedEmailAddressData) {
    this.password = "";
    this.data = data;

    this.message = this.$t("joinSharedEmailAddress.formatMessage", [
      data.emailAddress,
    ]).toString();

    this.baseDialogComponent.show({
      title: this.$t("joinSharedEmailAddress.title").toString(),
      closeOnSave: false,
      persistent: true,
    });

    return new Promise<boolean>((resolve, reject) => {
      this.resolve = resolve;
      this.reject = reject;
    });
  }

  async onSave() {
    this.isLoading = true;

    const wasSuccessful = await tryJoinSharedEmailAddress({
      ...this.data,
      createdBy: getActiveUser()?.id ?? "",
      password: this.password,
    });

    this.isLoading = false;

    if (!wasSuccessful) {
      this.passwordError = [
        this.$t("joinSharedEmailAddress.errorWrongPassword").toString(),
      ];
      return;
    }

    this.resolve && this.resolve(true);
    this.baseDialogComponent.isShowing = false;
  }
}
